var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bullet font-600 font-14px flex-center"},[_vm._v(" "+_vm._s(_vm.count)+" ")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }